var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-wrapper"},[(_vm.image === undefined)?_c('AircraftBannerSkeleton'):_c('img',{staticClass:"banner",attrs:{"src":("" + _vm.image),"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }